import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform<T extends object>(items: readonly T[] | null | undefined, searchText: string, meta?: { count?: number; key?: string }): T[] {
    if (!items) return [];

    if (!searchText) {
      meta ? (meta.count = items.length) : undefined;
      return items as T[];
    }

    const filteredItems = items.filter((item) => {
      return Object.keys(item).some((key) => {
        let _k = meta && meta.key ? meta.key : key;
        return String(item[_k as keyof typeof item])
          .toLowerCase()
          .includes(searchText.toLowerCase());
      });
    });

    meta ? (meta.count = filteredItems.length) : undefined;
    return filteredItems;
  }
}
